export const SocialData=[

    {
        platform:"Github",
        icon: require("../../assets/icons/github.png"),
        link:"https://github.com/KERROUFIRDAOUS",
    },
    {
        platform:"Youtube",
        icon: require("../../assets/icons/youtube.png"),
        link:"https://www.youtube.com/channel/UCRtU2I8Xq1Uosd-gaQaiNAw",
    },
    {
        platform:"Twitter",
        icon: require("../../assets/icons/twitter.png"),
        link: "https://twitter.com/Firdaouskb1",
    },
    {
        platform:"Facebook",
        icon: require("../../assets/icons/facebook.png"),
        link:"https://web.facebook.com/profile.php?id=100087526339685",
    },
];